/* eslint-disable no-use-before-define */
import React from 'react'
import SearchHolding from './search-holding'
import DatePicker from '../date-picker'
import Tags from './tags'
import useHoldingSearch from './use-holding-search'
import {Loading} from '../../../twd'

export default () => {
    const { status, error, selected, setSelected } = useHoldingSearch()

    return <Loading status={status} error={error}>
    <div className="vertical-offset-xs"
        style={{
            padding: '10px',
            backgroundColor:"#f6f6f6"
        }}>

    <div className="row">
    <div className="col-md-7 col-xs-12">
        <div className="form-horizontal">
        <div className="form-group col-md-7" style={{marginBottom:0}}>
            <label>Issuer</label>
            <SearchHolding  selected={selected} setSelected={setSelected} />
        </div>
        </div>
    </div>

    <div className="col-md-5 col-xs-12">
        <DatePicker type="holding" />
    </div>
    </div>
    </div>

    <div className="row">
    <div className="col-md-12 col-xs-12">
        <Tags selected={selected} setSelected={setSelected} />
    </div>
    </div>
    </Loading>

}
